import styled from 'styled-components';

export const Separator = styled.hr`
  margin: 32px 0 0;
  width: 100%;
`;
